import { memo } from "react";
import { canv } from "@/canv/global";
import { getFilterIcon, getFilterName } from "../../lib";
import { getSelectedWidgetCountsByType } from "../../lib/getSelectedWidgetCountsByType";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./FilterMenu.module.css";

interface FilterMenuContentProps {
    onClick: (entityType: string) => void;
}

export const FilterMenuContent = memo(function FilterMenuContent({
    onClick,
}: FilterMenuContentProps) {
    const map = getSelectedWidgetCountsByType(canv.canvasController.selected);

    return (
        <>
            {[...map.entries()].map(([key, value]) => {
                const Icon = getFilterIcon(key);
                return (
                    <MenuButton className={styles.item} key={key} onClick={() => onClick(key)}>
                        {typeof Icon === "string" ? Icon : <Icon />}{" "}
                        <span className={styles.text}>{getFilterName(key)}</span>{" "}
                        <span>{value}</span>
                    </MenuButton>
                );
            })}
        </>
    );
});
